import course from '@/api/course';

import {
    RESET_COURSES,
    FETCH_ONE,
    FETCH_NEXT,
    FETCH_EARLIER_COURSES,
    FETCH_LATER_COURSES,
    CREATE_DRAFT_COURSE,
    COURSE_DRAFT_INITIALIZE,
} from './types';

export default {
    [FETCH_ONE]({ commit }, payload) {
        return course.get(payload.id)
            .then(resp => commit(FETCH_ONE, resp));
    },
    [FETCH_NEXT]({ commit }) {
        commit(RESET_COURSES);
        return course.getNext()
            .then(resp => commit(FETCH_NEXT, resp));
    },
    [FETCH_EARLIER_COURSES]({ state, commit }) {
        return course
            .getEarlierCourses(state.earlier_boundary.date, state.earlier_boundary.time)
            .then(resp => commit(FETCH_EARLIER_COURSES, resp));
    },
    [FETCH_LATER_COURSES]({ state, commit }) {
        return course
            .getLaterCourses(state.later_boundary.date, state.later_boundary.time)
            .then(resp => commit(FETCH_LATER_COURSES, resp));
    },
    [CREATE_DRAFT_COURSE]({ commit }, payload) {
        return course
            .createDraft(payload)
            .then((resp) => {
                commit(CREATE_DRAFT_COURSE, resp);
                commit(COURSE_DRAFT_INITIALIZE);
            });
    },
};



// WEBPACK FOOTER //
// ./src/store/course/actions.js